import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import { store } from "./store/store";
import AdminRoute from "./Admin/router";
Vue.use(Router);

let mainViews = [];
mainViews = [
  {
    path: "/",
    name: "home",
    component: Home,
    meta: {
      layout: "default"
    }
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "./views/About.vue"),
    meta: {
      layout: "cardbody",
      title: "About Us"
    }
  },
  {
    path: "/contact-us",
    name: "contactUs",
    component: () =>
      import(/* webpackChunkName: "contactUs" */ "./views/ContactUs.vue"),
    meta: {
      layout: "cardbody",
      title: "Contact Us"
    }
  },
  {
    path: "/register",
    name: "register",
    component: () =>
      import(/* webpackChunkName: "Register" */ "./views/Register.vue"),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/register_step_2",
    name: "registerStepTwo",
    component: () =>
      import(/* webpackChunkName: "Register" */ "./views/RegisterStepTwo.vue"),
    meta: {
      layout: "cardbody"
    }
  },
  {
    path: "/courses",
    name: "courses",
    component: () =>
      import(/* webpackChunkName: "Courses" */ "./views/CourseListing.vue"),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/live_courses",
    name: "liveCourses",
    component: () =>
      import(/* webpackChunkName: "Courses" */ "./views/LiveListing.vue"),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/play_video",
    name: "playVideo",
    component: () =>
      import(/* webpackChunkName: "playVideo" */ "./views/playVideo.vue"),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/course_description",
    name: "course",
    component: () =>
      import(/* webpackChunkName: "Coursedescription" */ "./views/CourseDescription.vue"),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/all_courses",
    name: "allCourses",
    component: () =>
      import(/* webpackChunkName: "Allcourses" */ "./views/AllCourseListing.vue"),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/resetPassword/:token",
    name: "resetPassword",
    component: () =>
      import(/* webpackChunkName: "resetPassword" */ "./views/ResetPassword.vue"),
    meta: {
      layout: "blank",
      title: "Reset Password"
    }
  },
  {
    path: "/become_a_teacher",
    name: "becomeateacher",
    component: () =>
      import(/* webpackChunkName: "Becomeateacher" */ "./views/BecomeATeacher.vue"),
    meta: {
      layout: "cardbody",
      title: "Contribute as a teacher and earn money"
    }
  },
  {
    path: "/student/wishlist",
    name: "wishlist",
    component: () =>
      import(/* webpackChunkName: "wishlist" */ "./views/Wishlist.vue"),
    meta: {
      layout: "dashboard",
      requiredAuth: true
    }
  },
  {
    path: "/cart",
    name: "cart",
    component: () => import(/* webpackChunkName: "cart" */ "./views/Cart.vue"),
    meta: {
      layout: "cardbody",
      title: "Shopping Cart"
    }
  },
  {
    path: "/all_teachers",
    name: "allTeachers",
    component: () =>
      import(/* webpackChunkName: "allTeachers" */ "./views/AllTeachers.vue"),
    meta: {
      layout: "cardbody",
      title: "Search our Awesome Teachers"
    }
  },
  {
    path: "/course_subscription",
    name: "course_subscription",
    component: () =>
      import(/* webpackChunkName: "course_subscription" */ "./views/CourseSubscription.vue"),
    meta: {
      layout: "cardbody",
      title: "Subscribe course",
      requiredAuth: true
    }
  },
  {
    path: "/request_course",
    name: "request-course",
    component: () =>
      import(/* webpackChunkName:  "request-course" */ "./views/RequestCourse.vue"),
    meta: {
      layout: "cardbody",
      title: "Can't find the course you are looking for ?",
      requiredAuth: true
    }
  },
  {
    path: "/student/dashboard",
    name: "userdashboard",
    component: () =>
      import(/* webpackChunkName: "userdashboard" */ "./views/UserDashboard.vue"),
    meta: {
      layout: "dashboard",
      requiredAuth: true
    }
  },
  {
    path: "/help",
    name: "help",
    component: () => import(/* webpackChunkName: "help" */ "./views/help.vue"),
    meta: {
      layout: "cardbody",
      title: "Help Center Find answer for FAQ"
    }
  },
  {
    path: "/teacher",
    name: "Teacher",
    component: () =>
      import(/* webpackChunkName: "teacher" */ "./views/Teacher.vue"),
    meta: {
      layout: "cardbody",
      title: " "
    }
  },
  {
    path: "/student/following",
    name: "Following",
    component: () =>
      import(/* webpackChunkName: "Following" */ "./views/Following.vue"),
    meta: {
      layout: "dashboard",
      requiredAuth: true
    }
  },
  {
    path: "/student/edit_profile",
    name: "EditProfile",
    component: () =>
      import(/* webpackChunkName: "EditProfile" */ "./views/EditProfile.vue"),
    meta: {
      layout: "dashboard",
      requiredAuth: true
    }
  },
  {
    path: "/student/my_courses",
    name: "MyCourses",
    component: () =>
      import(/* webpackChunkName: "MyCourses" */ "./views/MyCourses.vue"),
    meta: {
      layout: "dashboard",
      requiredAuth: true
    }
  }
];

let allRoutes = [];
allRoutes = allRoutes.concat(mainViews, AdminRoute);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: allRoutes,
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    };
  }
});

router.beforeEach((to, from, next) => {
  // Check for requiresAuth guard
  if (to.matched.some(record => record.meta.requiredAuth)) {
    // Check if NO logged user
    if (to.path.includes("/admin/") || to.path.includes("/student/")) {
      if (store.state.user.loginStatus === false) {
        next({ path: "/" });
      } else {
        next();
      }
    } else if (to.path === "/course_subscription") {
      if (store.state.user.loginStatus === false) {
        next({
          path: "/course_description",
          query: {
            courseId: store.state.courses.selectedCourse.course_id,
            courseType: store.state.courses.selectedCourse.isLiveCourse
              ? "liveCourse"
              : "course"
          }
        });
      } else {
        next();
      }
    }
  }
  next();
});
export default router;
